import { render } from "./PracticeTestCard.vue?vue&type=template&id=70397a3c&scoped=true"
import script from "./PracticeTestCard.vue?vue&type=script&lang=js"
export * from "./PracticeTestCard.vue?vue&type=script&lang=js"

import "./PracticeTestCard.vue?vue&type=style&index=0&id=70397a3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70397a3c"]])

export default __exports__